import React__default from 'react';

const tableRow = "_table-row_l4x2k_1";
const styles = {
	tableRow: tableRow
};

const TableRow = (props) => {
  return React__default.createElement("tr", { className: styles.tableRow, role: "row", "data-zds": true }, props.children);
};

export { TableRow };
//# sourceMappingURL=TableRow.es.js.map
